import { useState } from 'react';

const FAQS = [
  {
    q: '歪歪漫画网需要注册才能看漫画吗？',
    a: '不需要。歪歪漫画网始终坚持免费开放原则，所有漫画内容均可直接在线观看和阅读，无需注册或登录。打开网站即可畅享海量漫画资源，下拉式阅读模式让你无缝追更。',
  },
  {
    q: '歪歪漫画网的漫画多久更新一次？',
    a: '我们每日稳定更新超过200部热门漫画连载。编辑团队实时追踪各大漫画平台的最新章节，确保热门韩漫、日漫、国漫在第一时间同步更新，追更党不用苦等。',
  },
  {
    q: '歪歪漫画网支持手机端阅读吗？',
    a: '完全支持。歪歪漫画网采用响应式设计，完美适配手机、平板和电脑端。特别优化的下拉式阅读模式在移动端体验极佳，向下滑动即可无缝衔接下一话，无需点击翻页按钮。',
  },
  {
    q: '歪歪漫画网有哪些漫画类型？',
    a: '我们覆盖了几乎所有热门漫画类型，包括但不限于：韩漫热门、日漫经典、国漫崛起、热血冒险、恋爱甜宠、奇幻异界、悬疑推理、搞笑日常、都市情感、古风仙侠、耽美专区等。无论你喜欢什么类型，都能在这里找到心仪的作品。',
  },
  {
    q: '漫画加载慢或无法显示怎么办？',
    a: '如果遇到漫画加载缓慢的情况，建议检查网络连接或尝试刷新页面。我们的服务器已针对图片加载做了深度优化，通常情况下阅读体验非常流畅。如持续出现问题，欢迎通过意见反馈邮箱联系我们。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于歪歪漫画网，你想知道的都在这里
        </p>
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4 font-heading">
                  {faq.q}
                </h3>
                <span className={`w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}